import React, { Component } from 'react';
import '../static/css/bootstrap.min.css'
import '../index.css'
import image from '../resources/p9_img1.png'

class Section9 extends Component {
  render() {
    return (
      <section id="page_9">
        <div className="container" >
          <div className="row">
            <div className="col-sm-6 col-xs-12">
              <div className="img_wrapper">
                <img src={image} className="img-responsive" alt="page_9_image"/>
              </div>
            </div>

            <div className="col-sm-6 col-xs-12">
              <div className="content_wrapper">
                <div className="title">
                  生徒たちから大好評の<br />
                  Musio。
                </div>

                <div className="content1">
                  2018年現在、Musioは新潟県柏崎市や山口県宇部市の小中学校や同志社中学校、京都大学、デジタルハリウッド大学などで導入・活用されています。
                  Musioの授業を受けた生徒のみなさんからは多くのご好評をいただいています。
                </div>

                <div className="content2">
                  <span className="highlight">96％</span>の生徒*<br />
                  <span className="highlight">「英語学習が楽しくなった」</span>
                </div>

                <div className="content3">
                  <span className="highlight">70％</span>以上の生徒*<br />
                  <span className="highlight">「英語力がアップしたと感じる」</span>
                </div>

                <div className="content4 highlight">
                  英語に対するモチベーションと<br />
                  スピーキングの実力向上に効果的。
                </div>

                <div className="text-right comment">
                  * Source: Musio授業関連アンケート調査（同志社中学校. 2018.02 実施）
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Section9;



// WEBPACK FOOTER //
// ./src/sections/Section9.js